import { API } from '@/api/api';
import { isNotFound, isPermissionDenied } from '@/common/error';

// Files are no longer served from the storage bucket: every service hands out a *private
// link* — an absolute `…/api/v1/<service>/files/…` URL that only answers to the bearer
// token, and on the vessel service to the `X-Service-Id` header as well. A plain
// `<img src>` can attach neither, so it gets a 403; such a link has to be fetched through
// axios and shown as a `blob:` URL instead — see `useAuthorizedFileUrl`.
//
// Anything else — a bundled asset, a local `blob:`/`data:` preview — is used as it is.
export const isAuthorizedFileLink = (link?: null | string): link is string =>
  !!link && link.includes('/api/v1/');

/**
 * Whose client carries the link. It is absolute, so the base URL plays no part — this only
 * keeps a file request on the service that issued it.
 */
export const fileLinkApi = (link: string): API =>
  link.includes('/api/v1/vessel/') ? API.VESSEL : API.PEOPLE;

export const AUTHORIZED_FILE_QUERY_KEY = 'authorized-file';

/** Keyed by the link alone, so every place showing one file shares a single request. */
export const authorizedFileQueryKey = (link: null | string | undefined) =>
  [AUTHORIZED_FILE_QUERY_KEY, link] as const;

/**
 * A refusal asking again cannot change: the file is gone, or this seat may not open it.
 * Both are settled, and retrying only multiplies the failed requests behind every thumbnail.
 */
export const isFileUnavailable = (error: unknown) => isNotFound(error) || isPermissionDenied(error);
